import { register } from 'register-service-worker';
//import router from './router';

//window.addEventListener('online', updateOnlineStatus);
//window.addEventListener('offline', updateOnlineStatus);
window.addEventListener('load', () => {
	localStorage.removeItem('hasReloaded');
});

console.log("Attempting to register service worker...", process.env.VUE_APP_ENABLE_SW);

if (process.env.NODE_ENV === 'production' || process.env.VUE_APP_ENABLE_SW === 'true') {
	register(`/service-worker.js`, {
		updateViaCache: 'none',
		ready() {
			console.log(
				'App is being served from cache by a service worker.\n' +
				'For more details, visit https://goo.gl/AFskqB'
			);
		},
		registered(registration) {
			console.log('Service worker has been registered.', registration);
		},
		cached() {
			console.log('Content has been cached for offline use.');
		},
		updatefound() {
			console.log('New content is downloading.');
		},
		updated() {
			if (!localStorage.getItem('hasReloaded')) {
				if (confirm('New version available. Do you want to reload the app now?')) {
					localStorage.setItem('hasReloaded', 'true');
					setTimeout(() => {
						window.location.reload();
					}, 100);
				}
			}
		},
		/* offline() {
			console.log('No internet connection found. App is running in offline mode.');
			router.push('/offline');
		}, */
		error(error) {
			console.error('Error during service worker registration:', error);
		}
	});
} else {
	console.log("Service worker conditions not met for registration.");
}
